module.exports = __webpack_public_path__ + "media/images/flags/tr-1a109fa73fffdfd33b11a168f71fa60f.svg";